import React from 'react'
import classes from '@src/styles/Values.module.css'

function Values() {
  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <h2 className={classes.header}>Our Values</h2>
        <div className={classes.listContainer}>
          <div className={classes.listItem}>
            <div>
              <h4 className={classes.smallHeader}>Reliable</h4>
              <span className={classes.listNumber}>01</span>
            </div>
            <p className={classes.description}>
              Our customers can rest easy, knowing that their waste is being handled by our trusted
              network of providers. If your original provider is unable to fulfil your request,
              we&apos;ll always ensure that a replacement is dispatched to you as soon as possible.
            </p>
          </div>
          <div className={classes.listItem}>
            <div>
              <h4 className={classes.smallHeader}>Revolutionary</h4>
              <span className={classes.listNumber}>02</span>
            </div>
            <p className={classes.description}>
              Dimension is here to radically change waste management with the power of technology.
            </p>
          </div>
          <div className={classes.listItem}>
            <div>
              <h4 className={classes.smallHeader}>Rewarding</h4>
              <span className={classes.listNumber}>03</span>
            </div>
            <p className={classes.description}>
              Dimension takes all the hassle out of managing waste, leaving our customers with more
              time to focus on the things that really matter to them.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Values
